import './index.erb';
import './index.rb';
import s from './index.module.scss';
import { EventManager } from 'utils/event_manager';

export default class Countdown {
  constructor(context) {
    this.intervalId = null;
    this.context = context;
    this.daysBox = this.context?.querySelector(`.${s.boxtimerDays}`);
    this.days = this.context?.querySelector(
      `.${s.boxtimerDays} > .${s.counter}`
    );
    this.hours = this.context?.querySelector(
      `.${s.boxtimerHours} > .${s.counter}`
    );
    this.minutes = this.context?.querySelector(
      `.${s.boxtimerMinutes} > .${s.counter}`
    );
    this.seconds = this.context?.querySelector(
      `.${s.boxtimerSeconds} > .${s.counter}`
    );
    this.dueDate = new Date(this.context?.dataset.dueDate);

    this.bind();
  }

  timer() {
    if (!this.context || !this.dueDate) {
      return;
    }

    var currentTime = new Date();
    var interval = this.dueDate - currentTime;

    if (interval > 0) {
      var countDays = Math.floor(interval / (1000 * 60 * 60 * 24));
      var countHours = Math.floor(
        (interval % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var countMinutes = Math.floor(
        (interval % (1000 * 60 * 60)) / (1000 * 60)
      );
      var countSeconds = Math.floor((interval % (1000 * 60)) / 1000);

      this.days.innerHTML = countDays;
      this.hours.innerHTML = countHours;
      this.minutes.innerHTML = countMinutes;
      this.seconds.innerHTML = countSeconds;

      if (countDays < 1) {
        this.daysBox.classList.add('hidden');
      }
    } else {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      EventManager.publish('pure-countdown:finished', {
        context: this.context
      });
    }
  }

  bind() {
    this.intervalId = setInterval(() => this.timer(), 1000);
  }
}

(() => {
  const countDowns = document.querySelectorAll(`.${s.root}`);
  const countDownsArray = Array.from(countDowns);

  countDownsArray.forEach(element => new Countdown(element));
})();
